import { NotificationSettings } from "@/types/notificationSettings";
import { BaseService } from "./base.service";

export class NotificationSettingsService extends BaseService {
  constructor() {
    super("/notification-settings");
  }

  // Fetch current notification settings
  async getSettings(): Promise<NotificationSettings> {
    return await this.get<NotificationSettings>("");
  }

  // Update notification settings
  async updateSettings(
    settings: Partial<NotificationSettings>
  ): Promise<NotificationSettings> {
    return await this.put<NotificationSettings>("", settings);
  }
}

export const notificationSettingsService = new NotificationSettingsService();
